import { makeStyles } from '@mui/styles'
import { Theme } from '../../../../../UI'

export default makeStyles((theme: Theme) => ({
  container: {
    height: '300px',
    overflow: 'overlay',
  },
  notes: {
    marginBottom: '1rem !important',
  }
}))
